export default (sportEventPathId) => sportEventPathId === 364;
